import Papa from 'papaparse';
import { downloadBlob } from './FileDownloadHelper';
import ormToast, { TOAST_TYPE } from './ormToast';

const CSV_MIME_TYPE = 'text/csv;charset=utf-8;';

export const convertToCSV = (data, options = { skipEmptyLines: true }) => Papa.unparse(data, options);

export const createCsvBlob = csvContent => new Blob([csvContent], { type: CSV_MIME_TYPE });

export const downloadCSV = (data, fileName, options = { skipEmptyLines: true }) => {
  const csvContent = convertToCSV(data, options);
  downloadBlob(createCsvBlob(csvContent), fileName);
  ormToast('CSV download successfully', TOAST_TYPE.SUCCESS);
};

export const downloadCsvText = (csvContent, fileName) => {
  downloadBlob(createCsvBlob(csvContent), fileName);
};

export const mergeCsvParts = csvParts => {
  if (!csvParts.length) return '';

  const [firstCsv, ...restCsvs] = csvParts;
  const lines = firstCsv.split('\n');
  const header = lines[0];
  const firstBody = lines.slice(1).join('\n');
  const otherBodies = restCsvs.map(csv => csv.split('\n').slice(1).join('\n')).join('\n');

  return [header, firstBody, otherBodies].filter(Boolean).join('\n');
};
